/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export var MembershipTypeMethod = /*#__PURE__*/function (MembershipTypeMethod) {
  MembershipTypeMethod["A_1"] = "A_1";
  MembershipTypeMethod["A_2"] = "A_2";
  return MembershipTypeMethod;
}({});
export var MembershipTypeTag = /*#__PURE__*/function (MembershipTypeTag) {
  MembershipTypeTag["BECADO"] = "BECADO";
  MembershipTypeTag["FAMILIAR"] = "FAMILIAR";
  MembershipTypeTag["ONG_BECADO"] = "ONG_BECADO";
  MembershipTypeTag["ORGANIZATION"] = "ORGANIZATION";
  MembershipTypeTag["PLUS"] = "PLUS";
  MembershipTypeTag["PREMIUM"] = "PREMIUM";
  MembershipTypeTag["PREMIUM_DUO"] = "PREMIUM_DUO";
  MembershipTypeTag["PREMIUM_LITE"] = "PREMIUM_LITE";
  MembershipTypeTag["PREMIUM_STUDENT"] = "PREMIUM_STUDENT";
  MembershipTypeTag["PROFESIONAL"] = "PROFESIONAL";
  MembershipTypeTag["UNIVERSITY_SCHOLARSHIP"] = "UNIVERSITY_SCHOLARSHIP";
  return MembershipTypeTag;
}({});
export var MyUserTypeDocument = /*#__PURE__*/function (MyUserTypeDocument) {
  MyUserTypeDocument["DNI"] = "DNI";
  MyUserTypeDocument["FOREIGNER_CARD"] = "FOREIGNER_CARD";
  MyUserTypeDocument["PASSPORT"] = "PASSPORT";
  return MyUserTypeDocument;
}({});
export var UserB2BStatusEnum = /*#__PURE__*/function (UserB2BStatusEnum) {
  UserB2BStatusEnum["ACTIVE"] = "ACTIVE";
  UserB2BStatusEnum["DELETE"] = "DELETE";
  UserB2BStatusEnum["INACTIVE"] = "INACTIVE";
  UserB2BStatusEnum["PENDING"] = "PENDING";
  return UserB2BStatusEnum;
}({});
export var UserDegreeSegmentationEnum = /*#__PURE__*/function (UserDegreeSegmentationEnum) {
  UserDegreeSegmentationEnum["ACTIVATED_DEGREE_SEGMENTATION"] = "ACTIVATED_DEGREE_SEGMENTATION";
  UserDegreeSegmentationEnum["EXPIRED_DEGREE_SEGMENTATION"] = "EXPIRED_DEGREE_SEGMENTATION";
  return UserDegreeSegmentationEnum;
}({});
export var UserTagEnum = /*#__PURE__*/function (UserTagEnum) {
  UserTagEnum["B2B"] = "B2B";
  UserTagEnum["COLLEGE_SCHOLARSHIP"] = "COLLEGE_SCHOLARSHIP";
  UserTagEnum["MENTOR"] = "MENTOR";
  UserTagEnum["MENTOR_STAR"] = "MENTOR_STAR";
  UserTagEnum["PLUS"] = "PLUS";
  UserTagEnum["PREMIUM"] = "PREMIUM";
  UserTagEnum["PREMIUM_LITE"] = "PREMIUM_LITE";
  UserTagEnum["PREMIUM_STUDENT"] = "PREMIUM_STUDENT";
  UserTagEnum["PROFESSIONAL"] = "PROFESSIONAL";
  UserTagEnum["PROFESSOR"] = "PROFESSOR";
  UserTagEnum["SCHOLARSHIP"] = "SCHOLARSHIP";
  UserTagEnum["STAFF"] = "STAFF";
  return UserTagEnum;
}({});

//==============================================================
// END Enums and Input Objects
//==============================================================